import './bg.css'

const Background = () => {

      return (
            <div className="background_content">
                  <div className="background_inner">
                        <div className="circle_bg"></div>
                        <div className="circle_bg"></div>
                        <div className="square_bg"></div>
                        <div className="square_bg"></div>
                  </div>
            </div>
      )
}

export default Background
